export default __webpack_public_path__ + "static/media/demoAll.1160d9ba.mp4";